import React from "react";

interface Review {
  name: string;
  text: string;
}

interface ReviewMarqueeProps {
  reviews: Review[];
}

const ReviewMarquee: React.FC<ReviewMarqueeProps> = ({ reviews }) => (
  <section data-section="reviews" className="py-8 md:py-12">
    <div className="max-w-3xl mx-auto px-4">
      <h2 className="text-2xl font-bold text-white mb-6 text-center">What Guests Say</h2>
      <div className="overflow-x-auto whitespace-nowrap flex gap-4 pb-2">
        {reviews.map((review, i) => (
          <div key={i} className="inline-block bg-white/5 rounded-xl p-4 shadow-md min-w-[220px] max-w-xs text-white">
            <div className="text-sm mb-2">“{review.text}”</div>
            <div className="text-xs text-white/70 text-right">— {review.name}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ReviewMarquee;
